import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';
import { EmptyState } from '@/components/ui/EmptyState';
import { useSystemAlerts } from '@/hooks/useAdminMonitoring';
import { AlertTriangle, CheckCircle, Bell } from 'lucide-react';

export function SystemAlertsCard() {
  const { data, isLoading } = useSystemAlerts();
  const alerts = data?.alerts || [];

  return (
    <Card>
      <CardHeader title="Alertes système" icon={<Bell className="h-4 w-4" />} />
      <CardContent>
        {!isLoading && alerts.length === 0 ? (
          <EmptyState
            message="Aucune alerte"
            icon={<CheckCircle className="h-8 w-8 text-success-400" />}
          />
        ) : (
          <div className="space-y-2">
            {alerts.map((alert: { type: string; message: string; link?: string }, index: number) => (
              <div
                key={index}
                className="flex items-start gap-3 rounded-xl border border-neutral-200 p-3 transition-colors duration-200 hover:bg-neutral-50 dark:border-neutral-800 dark:hover:bg-neutral-800/30"
              >
                <AlertTriangle className={`mt-0.5 h-4 w-4 shrink-0 ${alert.type === 'warning' ? 'text-warning-400' : 'text-primary-400'}`} />
                <div className="flex-1">
                  <p className="text-sm text-neutral-700 dark:text-neutral-300">{alert.message}</p>
                </div>
                <Badge variant={alert.type === 'warning' ? 'warning' : 'info'}>
                  {alert.type === 'warning' ? 'Attention' : 'Info'}
                </Badge>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
